import { useState, useEffect } from 'react';
import {css, useTheme} from '@emotion/react';
import Image from 'next/image';
import Link from 'next/link';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';

const NotFoundPage = () => {
    const [title, setTitle] = useState("");
    const [isVisible, setVisible] = useState(false);
    const theme = useTheme()

    useEffect(() => {
        const fullTitle = "How did you get here?";
        let frame = 0;

        const interval = setInterval(() => {
            frame += 3;
            const dots = ".".repeat(Math.min(frame, 4));
            const text = fullTitle.slice(0, Math.max(frame - 4, 0));
            setTitle(`${dots} ${text}`);
            if (frame >= fullTitle.length + 4) {
                clearInterval(interval);
                setVisible(true);
            }
        }, 500);

        return () => clearInterval(interval);
    }, []);

    return (
        <article>
            <Container css={styles(theme)} maxWidth="md" component="main" role="main" align="center" isVisible={isVisible}>
                <Typography variant="h2" align="center">{title}</Typography>
                <Link href="/">
                    <figure>
                        <Image
                            src={"/imgs/sprites/404.webp"}
                            width={500}
                            height={500}
                            alt="red panda in the middle of two 4s"
                        />
                        <figcaption className='caption' style={{ display: isVisible ? 'block' : 'none' }}>sometimes I worry about you</figcaption>
                    </figure>
                </Link>
            </Container>
        </article>
    );
};

export default NotFoundPage;

const styles = (theme) => css`
    width: 80vw;
    height: 80vh;
    padding: 5rem;

    figure {
        position: relative;
        width: 450px;
        height: 450px;
        margin: auto;
    }

    .caption {
        padding: 2rem;
        font-size: 1.5rem;
        color: ${theme.palette.primary.main};
        text-decoration: underline;
        cursor: pointer;
        padding: 0.5rem 1rem;
        border-radius: 0.25rem;
        transition: background-color 0.3s, color 0.3s;

        &:hover {
            background-color: ${theme.palette.primary.light};
            color: ${theme.palette.primary.contrastText};
        }
    }
`;

